/**
 * Centralized localStorage key management
 * This ensures we can easily track and clear all user-specific data
 */
export const STORAGE_KEYS = {
  TOKEN: 'token',
  SELECTED_SESSION_ID: 'selectedSessionId',
  DASHBOARD_LAYOUT: 'dashboardLayout',
  TRACK_VIEW_MODE: 'laptura_track_view_mode',
  SHOW_SPEED_TRACE: 'laptura_show_speed_trace',
  SHOW_RPM_TRACE: 'laptura_show_rpm_trace',
  ACTIVE_CHANNEL: 'laptura_active_channel',
  DOCK_CHANNELS: 'laptura_dock_channels',
  DEMO_MODE: 'demoMode',
};

/**
 * Get all user-specific localStorage keys (excluding token which is handled separately)
 */
export const getUserSpecificStorageKeys = () => {
  return [
    STORAGE_KEYS.SELECTED_SESSION_ID,
    STORAGE_KEYS.DASHBOARD_LAYOUT,
    STORAGE_KEYS.TRACK_VIEW_MODE,
    STORAGE_KEYS.SHOW_SPEED_TRACE,
    STORAGE_KEYS.SHOW_RPM_TRACE,
    STORAGE_KEYS.ACTIVE_CHANNEL,
    STORAGE_KEYS.DOCK_CHANNELS,
  ];
};

/**
 * Clear all user-specific localStorage data
 */
export const clearUserSpecificStorage = () => {
  const keys = getUserSpecificStorageKeys();
  keys.forEach(key => localStorage.removeItem(key));
};

/**
 * JWT: localStorage is the lasting login (new tab / quit browser).
 * sessionStorage is this tab's pin so another tab's login cannot steal
 * this tab's next request. First read copies the lasting token into the pin.
 */
export const getAuthToken = () => {
  const pinned = sessionStorage.getItem(STORAGE_KEYS.TOKEN);
  if (pinned) return pinned;
  const shared = localStorage.getItem(STORAGE_KEYS.TOKEN);
  if (shared) sessionStorage.setItem(STORAGE_KEYS.TOKEN, shared);
  return shared;
};

export const setAuthToken = (token) => {
  sessionStorage.setItem(STORAGE_KEYS.TOKEN, token);
  localStorage.setItem(STORAGE_KEYS.TOKEN, token);
};

export const clearAuthToken = () => {
  sessionStorage.removeItem(STORAGE_KEYS.TOKEN);
  localStorage.removeItem(STORAGE_KEYS.TOKEN);
};
